import * as serviceCategory from './serviceCategory.service';
import * as serviceType from './serviceType.service';
import * as serviceSubcategory from './serviceSubcategory.service';

export const ManageServices = {
  ...serviceCategory,
  ...serviceType,
  ...serviceSubcategory,
};
